import { zodResolver } from "@hookform/resolvers/zod"
import * as React from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { z } from "zod"
import { authApi } from "@/api/auth"
import { ApiError } from "@/api/client"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useAuth } from "@/hooks/use-auth"

const schema = z.object({ orgName: z.string().min(2, "En az 2 karakter.") })
type FormValues = z.infer<typeof schema>

export function OnboardingPage() {
  const [error, setError] = React.useState<string | null>(null)
  const { refresh } = useAuth()
  const nav = useNavigate()
  const form = useForm<FormValues>({ resolver: zodResolver(schema), defaultValues: { orgName: "" } })

  async function onSubmit(values: FormValues) {
    setError(null)
    try {
      await authApi.onboarding({ org_name: values.orgName })
      await refresh()
      nav("/dashboard", { replace: true })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "İşlem başarısız.")
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Şirketini oluştur</CardTitle>
        <CardDescription>
          Hirefy multi-tenant çalışır. Önce çalıştığın şirketi tanımla.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)} noValidate>
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <div className="space-y-1.5">
            <Label>Şirket adı</Label>
            <Input {...form.register("orgName")} />
            {form.formState.errors.orgName && (
              <p className="text-xs text-destructive">{form.formState.errors.orgName.message}</p>
            )}
          </div>
          <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
            Devam et
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}
